import { useState, useEffect } from 'react';
import OnboardingFlow from './components/layout/OnboardingFlow';
import PaymentErrorPopup from './components/PaymentErrorPopup';
import { OnboardingProvider } from './context/OnboardingContext';
import { initRinoAnalytics } from './services/rinoAnalytics';

function App() {

    console.log("App init");

    useEffect(() => {
        initRinoAnalytics('rino-funnels-v2');
    }, []);

    return (
        <OnboardingProvider>
            <div id="onboarding-container">
                <OnboardingFlow />
            </div>
            <PaymentErrorPopup />
        </OnboardingProvider>
    );
}

export default App;

